import * as EnglishUS from './en-US';
import type { IMessages } from './MessageKeys';

const languageCode = 'es-MX';

const messages: IMessages = {
	...EnglishUS.messages,
};

export { messages, languageCode };

export default messages;
